export default "__VITE_ASSET___app/immutable/assets/modal-logo-terminal.Cs4Cm_SQ.svg__"